import React, {useEffect, useRef} from 'react';

import './index.css';
import CheckIcon from "../../../assets/icons/CheckIcon";

/*
 * indeterminate is the third state the sheet draws: a box that is filled like a
 * checked one but carries a bar instead of a tick. It is what a "select all"
 * says when some of the rows under it are chosen and some are not.
 *
 * The browser has no attribute for it - it is a property on the element - so it
 * is set on the node itself, which is what makes a screen reader announce
 * "mixed" rather than "unchecked".
 */
const Checkbox = ({
                      disabled = false,
                      checked,
                      indeterminate = false,
                      handleChange,
                      style = {},
                      size = 18,
                      label,
                      onClick
                  }) => {

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = indeterminate && !checked;
        }
    }, [indeterminate, checked]);

    const classes = ['custom-checkbox'];
    if (disabled) classes.push('disabled');
    if (indeterminate && !checked) classes.push('indeterminate');

    return (
        <React.Fragment>
            <label className={classes.join(' ')} style={style} onClick={onClick}>
                <input
                    ref={inputRef}
                    type="checkbox"
                    checked={checked}
                    disabled={disabled}
                    onChange={(event) => {
                        handleChange(event.target.checked);
                    }}
                />
                <span className="checkmark" style={{width:`${size}px`,height:`${size}px`}}>
                    <CheckIcon
                        stroke={'#fff'}
                        height={size - 4}
                        width={size - 4}
                        className="check-icon"
                    />
                    <span className="checkmark-dash"/>
                </span>
                {label}
            </label>
        </React.Fragment>
    )
};


export default Checkbox;



// WEBPACK FOOTER //
// ./src/components-new/form/Checkbox/index.jsx